<form [formGroup]="transportForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{type}} Transport
        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content" style="margin-top: -15px;">
        <!-- Route Name -->
        <div class="field">
            <label class="requiredValue">Route Name</label>
            <input pInputText formControlName="route_name" placeholder="Enter Route Name" />
            <small *ngIf="transportForm.get('route_name')?.invalid && isSubmitted" class="p-error">
                Route Name is required
            </small>
        </div>

        <!-- Pickup and Drop Points -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Pickup Point</label>
                <input pInputText formControlName="pickup_point" placeholder="Enter Pickup Point" />
                <small *ngIf="transportForm.get('pickup_point')?.invalid && isSubmitted" class="p-error">
                    Pickup Point is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Drop Point</label>
                <input pInputText formControlName="drop_point" placeholder="Enter Drop Point" />
                <small *ngIf="transportForm.get('drop_point')?.invalid && isSubmitted" class="p-error">
                    Drop Point is required
                </small>
            </div>
        </div>

        <!-- Capacity and Fee Amount -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Capacity</label>
                <input pInputText formControlName="capacity" placeholder="Enter Capacity" type="number" />
                <small *ngIf="transportForm.get('capacity')?.invalid && isSubmitted" class="p-error">
                    Capacity is required and must be at least 1
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Fee Amount</label>
                <input pInputText formControlName="fee_amount" placeholder="Enter Fee Amount" type="number" />
                <small *ngIf="transportForm.get('fee_amount')?.invalid && isSubmitted" class="p-error">
                    Fee Amount is required and must be greater than 0
                </small>
            </div>
        </div>

        <!-- Currency and Vehicle Type -->
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
            <div class="field">
                <label class="requiredValue">Currency</label>
                <p-select [options]="currencyOptions" formControlName="currency" placeholder="Select Currency"></p-select>
                <small *ngIf="transportForm.get('currency')?.invalid && isSubmitted" class="p-error">
                    Currency is required
                </small>
            </div>

            <div class="field">
                <label class="requiredValue">Vehicle Type</label>
                <p-select [options]="vehicleTypeOptions" formControlName="vehicle_type" placeholder="Select Vehicle Type"></p-select>
                <small *ngIf="transportForm.get('vehicle_type')?.invalid && isSubmitted" class="p-error">
                    Vehicle Type is required
                </small>
            </div>
        </div>

        <!-- Amenities -->
        <div class="field">
            <label>Amenities</label>
            <p-multiSelect 
                [options]="amenitiesOptions" 
                formControlName="amenities" 
                placeholder="Select Amenities"
                optionLabel="label"
                optionValue="value"
                [showToggleAll]="true"
                class="w-full">
            </p-multiSelect>
        </div>

        <!-- Driver Details -->
        <div class="field">
            <label>Driver Details</label>
            <textarea pTextarea formControlName="driver_details" placeholder="Enter Driver Details" rows="3"></textarea>
        </div>

        <!-- Status -->
        <div class="field">
            <label class="requiredValue">Status</label>
            <p-select [options]="statusOptions" formControlName="status" placeholder="Select Status"></p-select>
            <small *ngIf="transportForm.get('status')?.invalid && isSubmitted" class="p-error">
                Status is required
            </small>
        </div>

        <!-- Action buttons -->
        <div class="flex justify-end gap-2 mt-8">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                (click)="onSubmit()"></p-button>
        </div>
    </div>
</form>